import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Container, LinearProgress } from '@mui/material'
import Header from './components/Header'
import Footer from './components/Footer'
import Analytics from './analytics'

const Home = lazy(() => import('./pages/Home'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Services = lazy(() => import('./pages/Services'))
const ServiceDetail = lazy(() => import('./pages/ServiceDetail'))
const Estimate = lazy(() => import('./pages/Estimate'))
const Deals = lazy(() => import('./pages/Deals'))
const Blogs = lazy(() => import('./pages/Blogs'))
const BlogDetail = lazy(() => import('./pages/BlogDetail'))
const NotFound = lazy(() => import('./pages/NotFound'))

export default function App() {
  return (
    <>
      <Header />
      <Analytics />
      <Suspense fallback={<Container sx={{ py: 6 }}><LinearProgress /></Container>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/estimate" element={<Estimate />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </>
  )
}
